import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { setDefault } from 'services/bankManagements'
interface IOpenBank {
    open: boolean
    item: IBankCardsResult | undefined
}
export default function useSetDefault(
    setIsOpen: React.Dispatch<React.SetStateAction<IOpenBank>>,
    refetch: () => void
) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (id: number) => {
            return setDefault(id)
        },
        onSuccess: (_, variables) => {
            toast.success('با موفقیت ثبت شد')
            setIsOpen({ open: false, item: undefined })
            refetch()
        },
        onError: () => {
            toast.error('خطایی رخ داده!')
        },
    })

    return { isLoading, defaultMutate: mutate }
}
